export default {
  'pantene-story-card': {
    mainWrapper:
      'relative flex md:flex-row-reverse md:items-end sm:flex-col md:justify-end picture-100 w-12/12 md:w-12/12 lg:w-12/12 sm:mb-26 md:mb-80',
    innerWrapper: 'innerWrapper',
    imageWrapper: 'imageWrapperSty md:w-3/5 relative pantene-story-card',
    textContent:
      'sm:w-11/12 md:w-6/12 sm:mx-auto text-left sm:my-30 md:my-0 md:-mr-10p sm:-mt-110 md:mt-0 md:pt-45 md:pb-0 md:px-30 z-10 bg-white sm:pt-30 sm:pb-14 sm:px-20',
    headingStyle: 'absolute bannerstory-t-text story-banner-text',
    subText:
      'font-BebasNeueRegular text-20 sm:leading-30 sm:tracking-1.4 sm:font-normal md:font-bold sm:text-left sm:pt-5 md:pt-0',
    subTitle:
      'font-HelveticaNeueLight sm:text-18 sm:text-left md:text-12 sm:leading-20 sm:mt-0 sm:p-0 sm:pt-10 md:pt-16',
  },
  'Nonobanner1-img-60-left-2':{
    mainWrapper:
      'relative flex md:flex-row-reverse md:items-center sm:flex-col md:justify-end picture-100 w-12/12 md:w-12/12 lg:w-12/12 mb-0 md:mb-80',
    innerWrapper: 'innerWrapper',
    imageWrapper: 'imageWrapperSty md:w-3/5 relative Nonobanner1-img-60-left-2',
    textContent:
      'sm:w-11/12 md:w-6/12 mx-auto text-left my-30 md:my-0 md:-mr-10p -mt-110 md:mt-0 md:py-20 md:px-30 z-10 bg-white pt-30 pb-14 px-20',
    headingStyle: 'absolute bannerstory-t-text story-banner-text',
    subText:
      'font-BebasNeueRegular text-20 sm:leading-30 sm:tracking-1.4 sm:font-normal md:font-bold sm:text-left sm:pt-5 md:pt-0',
    subTitle:
      'font-HelveticaNeueLight sm:text-18 sm:text-left md:text-14 sm:leading-28',
  },
  'Nonopantene-story-card': {
    mainWrapper:
      'relative flex md:flex-row-reverse md:items-center sm:flex-col md:justify-end picture-100 w-12/12 md:w-12/12 lg:w-12/12 sm:mb-26 md:mb-80',
    innerWrapper: 'innerWrapper',
    imageWrapper: 'md:w-3/5 relative Nonopantene-story-card',
    textContent:
      'sm:w-11/12 md:w-6/12 mx-auto text-left md:my-0 md:-mr-20p md:mt-0 md:py-20 md:px-30 z-10 bg-white pt-30 pb-14 px-20 nonoCardListProd',
    headingStyle: 'absolute bannerstory-t-text story-banner-text',
    subText:
      'font-BebasNeueRegular text-20 sm:leading-30 sm:tracking-1.4 sm:font-normal md:font-bold sm:text-left sm:pt-5 md:pt-0',
    subTitle:
      'text-justify text-14 leading-18  textDescribe',
    releatedCard: 'flex justify-center',
  },
  'SafetyTestedCard':{
    mainWrapper:
      'relative flex md:flex-row-reverse md:items-center sm:flex-col md:justify-end picture-100 w-12/12 md:w-12/12 lg:w-12/12 sm:mb-26 md:mb-20',
    innerWrapper: 'innerWrapper',
    imageWrapper: 'md:w-3/5 relative SafetyTestedCard',
    textContent:
      'w-full md:w-6/12 mx-auto text-left my-30 md:my-0 md:-mr-10p md:mt-0 md:py-20 md:px-30 z-10 bg-white pt-30 pb-14 px-20 safetyfour',
    headingStyle: 'absolute bannerstory-t-text story-banner-text',
    subText:
      'font-HelveticaNeueLight text-12 leading-20 text-justify sm:pt-5 md:pt-0 safteyCard',
    subTitle:
      'font-HelveticaNeueLight sm:text-18 sm:text-left md:text-14 sm:leading-28',
    releatedCard: 'flex',
    releatedCardLink: ''
  },
  'pantene-pro-v-story-card': {
    mainWrapper:
      'relative flex md:flex-row-reverse md:items-end sm:flex-col md:justify-end picture-100 w-12/12 md:w-12/12 lg:w-12/12 sm:mb-26 md:mb-80',
    innerWrapper: 'innerWrapper',
    imageWrapper: 'imageWrapperSty md:w-3/5 relative',
    textContent:
      'sm:w-11/12 md:w-8/12 sm:mx-auto text-left sm:my-30 md:mb-50 md:-mr-10p sm:-mt-110 md:mt-0 md:pt-45 md:pb-0 md:px-30 z-10 bg-white sm:pt-30 sm:pb-14 sm:px-20 min-h-full md:min-h-440 ',
    headingStyle: 'absolute bannerstory-t-text story-banner-text',
    subText:
      'font-BebasNeueRegular text-20 sm:leading-30 sm:tracking-1.4 sm:font-normal md:font-bold sm:text-left sm:pt-5 md:pt-0',
    subTitle:
      'font-HelveticaNeueLight sm:text-18 sm:text-left md:text-12 sm:leading-20 sm:mt-0 sm:p-0 sm:pt-10 md:pt-16',
  },
};
